module.exports = __webpack_public_path__ + "static/media/anish_shetty.f6e7c0fc.png";